module.exports = __webpack_public_path__ + "static/assets/4d2b4af5075d8b7bf7cd7bf046458045.svg";